<ng-container *ngIf="{
    row: columnData | async,
    adata: additionData | async
  } as $">

  <div (click)="OpenCouponPopup($.row)" *ngIf="$.row.coupon_type=='Vanity'" class="cursor-pointer text-primary">
    {{ getCouponCount($.row) }} {{ getCouponCount($.row) > 1 ? ('ADMIN.COUPON.CODES' | translate) : ('ADMIN.COUPON.CODE' | translate)}}
  </div>
  <div (click)="OpenCouponPopup($.row)" *ngIf="$.row.coupon_type !='Vanity'" class="cursor-pointer text-primary">
    {{$.row.coupon_codes.length}} {{ $.row.coupon_codes.length > 1 ? ('ADMIN.COUPON.CODES' | translate ) :('ADMIN.COUPON.CODE' | translate ) }}
  </div>
</ng-container>


<app-single-use-coupon *ngIf="(showSingleUseCoupon | async) as showPopup" [visible]="showPopup" [couponMaster]="couponMaster"
(closePopup)="closePopup($event)">
</app-single-use-coupon>

<app-vanity-coupon *ngIf="(showVanityCoupon | async) as showPopup" [visible]="showPopup" [couponMaster]="couponMaster"
(closePopup)="closePopup($event)">
</app-vanity-coupon>


